<p>lib-template-component works!</p>